import React from 'react';
import styles from './knowledge-item-row.module.scss';
import { formatFullName } from 'shared/utils';
import { useSelector } from 'react-redux';
import { getOwnersByIDs } from 'shared/store/selectors/owners.selector';
import { getLang } from 'shared/store/selectors/lang.selector';
import { useDateFormatter } from 'shared/hooks/dates.hooks';
import classNames from 'classnames';
import { RenderLabels } from 'src/components/common/categories/components';
import { getWorkspaces } from 'shared/store/selectors/workspace.selector';
import { useVettedOrProvidedLang } from 'shared/hooks/lang.hooks';
import { ItemType } from './item-type.component';

const KnowledgeItemRow = ({
  item,
  onSelect,
  disabled = false,
  selected = false,
  isHidden = false,
}) => {
  const {
    title,
    link,
    thumbnail,
    type,
    subtitle,
    ownerIds,
    updatedAt,
    labels,
    workspaceId,
    createdAt,
  } = item;
  const workspaces = useSelector(getWorkspaces);
  const knowledgeWorkspace = workspaces.find(w => w.id === workspaceId);
  const owners = useSelector(getOwnersByIDs(ownerIds));
  const { formatLongDate } = useDateFormatter();
  const showWorkspace = workspaces.length > 1 && knowledgeWorkspace;
  const lang = useSelector(getLang('CONTENT_SELECTOR'));
  const vettedByLang = useVettedOrProvidedLang(lang.VETTED_BY);

  const renderThumbnail = () => {
    if (!thumbnail) {
      return <ItemType type={type} link={link} className={styles.itemIcon} as="img" />;
    }

    return (
      <div className={styles.thumbnailWrapper}>
        <img src={thumbnail} alt={title} className={styles.thumbnail} />
      </div>
    );
  };

  return (
    <button
      type="button"
      className={classNames([
        'new-design-system',
        styles.container,
        disabled && styles.disabled,
        selected && styles.selected,
        isHidden && styles.hide,
      ])}
      onClick={() => onSelect(item)}
      disabled={disabled}
      role="option"
      aria-selected={selected}
    >
      <div className={styles.item}>
        <div className={styles.itemContent}>
          {renderThumbnail()}
          <div className={styles.textContainer}>
            <p className={styles.title}>{title}</p>
            {subtitle && <p className={styles.subtitle}>{subtitle}</p>}
            <div className={styles.footer}>
              {showWorkspace && (
                <span>
                  {lang.WORKSPACE} <strong>{knowledgeWorkspace.name}</strong>
                </span>
              )}
              {showWorkspace && owners.length > 0 && <span className={styles.divider}>|</span>}
              {owners.length > 0 && (
                <>
                  {vettedByLang}{' '}
                  {owners.map((owner, index) => (
                    <span key={index}>
                      <strong>{formatFullName(owner)}</strong>
                      {','}
                    </span>
                  ))}
                  {formatLongDate(updatedAt || createdAt)}
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      {labels && <RenderLabels labels={labels} styles={styles} />}
    </button>
  );
};

export { KnowledgeItemRow };
